// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityReportController from "./activity_report_controller"
application.register("activity-report", ActivityReportController)

import AdminCommunityConfirmationController from "./admin_community_confirmation_controller"
application.register("admin-community-confirmation", AdminCommunityConfirmationController)

import AdminEditController from "./admin_edit_controller"
application.register("admin-edit", AdminEditController)

import AdminMenuController from "./admin_menu_controller"
application.register("admin-menu", AdminMenuController)

import AdminPreambleController from "./admin_preamble_controller"
application.register("admin-preamble", AdminPreambleController)

import AdminScreenController from "./admin_screen_controller"
application.register("admin-screen", AdminScreenController)

import AdminSettingsController from "./admin_settings_controller"
application.register("admin-settings", AdminSettingsController)

import AdminToggleController from "./admin_toggle_controller"
application.register("admin-toggle", AdminToggleController)

import AdminToggleSettingController from "./admin_toggle_setting_controller"
application.register("admin-toggle-setting", AdminToggleSettingController)

import AdminWorkflowsController from "./admin_workflows_controller"
application.register("admin-workflows", AdminWorkflowsController)

import AgentFormController from "./agent_form_controller"
application.register("agent-form", AgentFormController)

import AudioPreviewController from "./audio_preview_controller"
application.register("audio-preview", AudioPreviewController)

import AudioUploadController from "./audio_upload_controller"
application.register("audio-upload", AudioUploadController)

import Bridge__EventController from "./bridge/event_controller"
application.register("bridge--event", Bridge__EventController)

import ChannelAttachmentController from "./channel_attachment_controller"
application.register("channel-attachment", ChannelAttachmentController)

import ChannelItemController from "./channel_item_controller"
application.register("channel-item", ChannelItemController)

import ChannelSelectorController from "./channel_selector_controller"
application.register("channel-selector", ChannelSelectorController)

import ChannelUploadController from "./channel_upload_controller"
application.register("channel-upload", ChannelUploadController)

import ChannelsController from "./channels_controller"
application.register("channels", ChannelsController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import ClearFieldsController from "./clear_fields_controller"
application.register("clear-fields", ClearFieldsController)

import ClickCatchController from "./click_catch_controller"
application.register("click-catch", ClickCatchController)

import ClickableController from "./clickable_controller"
application.register("clickable", ClickableController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommunityNotificationValidationController from "./community_notification_validation_controller"
application.register("community-notification-validation", CommunityNotificationValidationController)

import CommunityNotificationsController from "./community_notifications_controller"
application.register("community-notifications", CommunityNotificationsController)

import ConferenceParticipantsController from "./conference_participants_controller"
application.register("conference-participants", ConferenceParticipantsController)

import ConfirmToggleController from "./confirm_toggle_controller"
application.register("confirm-toggle", ConfirmToggleController)

import CraigReportController from "./craig_report_controller"
application.register("craig-report", CraigReportController)

import CriteriaGateController from "./criteria_gate_controller"
application.register("criteria-gate", CriteriaGateController)

import DashboardStatsController from "./dashboard_stats_controller"
application.register("dashboard-stats", DashboardStatsController)

import DemonstrationStepsController from "./demonstration_steps_controller"
application.register("demonstration-steps", DemonstrationStepsController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import DragItemController from "./drag_item_controller"
application.register("drag-item", DragItemController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DutyStatusController from "./duty_status_controller"
application.register("duty-status", DutyStatusController)

import DynamicConfirmController from "./dynamic_confirm_controller"
application.register("dynamic-confirm", DynamicConfirmController)

import EditWorkflowActivationController from "./edit_workflow_activation_controller"
application.register("edit-workflow-activation", EditWorkflowActivationController)

import EffectsController from "./effects_controller"
application.register("effects", EffectsController)

import FomanticPopupController from "./fomantic_popup_controller"
application.register("fomantic-popup", FomanticPopupController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import GroupsController from "./groups_controller"
application.register("groups", GroupsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageRetryController from "./image_retry_controller"
application.register("image-retry", ImageRetryController)

import LabelCheckController from "./label_check_controller"
application.register("label-check", LabelCheckController)

import LastUpdateController from "./last_update_controller"
application.register("last-update", LastUpdateController)

import LinkifyController from "./linkify_controller"
application.register("linkify", LinkifyController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import LocalNotificationController from "./local_notification_controller"
application.register("local-notification", LocalNotificationController)

import LocateController from "./locate_controller"
application.register("locate", LocateController)

import LocationRequestController from "./location_request_controller"
application.register("location-request", LocationRequestController)

import ManageMediaController from "./manage_media_controller"
application.register("manage-media", ManageMediaController)

import MapsController from "./maps_controller"
application.register("maps", MapsController)

import MemberController from "./member_controller"
application.register("member", MemberController)

import MembersController from "./members_controller"
application.register("members", MembersController)

import MessageDraftController from "./message_draft_controller"
application.register("message-draft", MessageDraftController)

import MessageReviewController from "./message_review_controller"
application.register("message-review", MessageReviewController)

import ModalStateController from "./modal_state_controller"
application.register("modal-state", ModalStateController)

import ModalsController from "./modals_controller"
application.register("modals", ModalsController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotificationContactsController from "./notification_contacts_controller"
application.register("notification-contacts", NotificationContactsController)

import NotificationContentController from "./notification_content_controller"
application.register("notification-content", NotificationContentController)

import NotificationResendsController from "./notification_resends_controller"
application.register("notification-resends", NotificationResendsController)

import NotificationSignaturesController from "./notification_signatures_controller"
application.register("notification-signatures", NotificationSignaturesController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import NotifyAtController from "./notify_at_controller"
application.register("notify-at", NotifyAtController)

import PhoneLinesController from "./phone_lines_controller"
application.register("phone-lines", PhoneLinesController)

import PhoneNumberStatusController from "./phone_number_status_controller"
application.register("phone-number-status", PhoneNumberStatusController)

import PlaceholderSelectorController from "./placeholder_selector_controller"
application.register("placeholder-selector", PlaceholderSelectorController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PollInstanceController from "./poll_instance_controller"
application.register("poll-instance", PollInstanceController)

import PollInstancesController from "./poll_instances_controller"
application.register("poll-instances", PollInstancesController)

import PollNotificationsController from "./poll_notifications_controller"
application.register("poll-notifications", PollNotificationsController)

import PollResponseController from "./poll_response_controller"
application.register("poll-response", PollResponseController)

import PollSelectionController from "./poll_selection_controller"
application.register("poll-selection", PollSelectionController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import PopupQuestionController from "./popup_question_controller"
application.register("popup-question", PopupQuestionController)

import PreparedMessagesController from "./prepared_messages_controller"
application.register("prepared-messages", PreparedMessagesController)

import QueryFormController from "./query_form_controller"
application.register("query-form", QueryFormController)

import RecordGreetingController from "./record_greeting_controller"
application.register("record-greeting", RecordGreetingController)

import RecordedGreetingsController from "./recorded_greetings_controller"
application.register("recorded-greetings", RecordedGreetingsController)

import ResourceToggleController from "./resource_toggle_controller"
application.register("resource-toggle", ResourceToggleController)

import S3AudioPreviewController from "./s3_audio_preview_controller"
application.register("s3-audio-preview", S3AudioPreviewController)

import ScheduleDaysController from "./schedule_days_controller"
application.register("schedule-days", ScheduleDaysController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import SectionCheckController from "./section_check_controller"
application.register("section-check", SectionCheckController)

import SelectItemController from "./select_Item_controller"
application.register("select-Item", SelectItemController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import SelectedValidationController from "./selected_validation_controller"
application.register("selected-validation", SelectedValidationController)

import SelectlistController from "./selectlist_controller"
application.register("selectlist", SelectlistController)

import SendViaController from "./send_via_controller"
application.register("send-via", SendViaController)

import SideToggleController from "./side_toggle_controller"
application.register("side-toggle", SideToggleController)

import SmsSegmentsController from "./sms_segments_controller"
application.register("sms-segments", SmsSegmentsController)

import SpokenController from "./spoken_controller"
application.register("spoken", SpokenController)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import StripeElementController from "./stripe_element_controller"
application.register("stripe-element", StripeElementController)

import SubmitFailureController from "./submit_failure_controller"
application.register("submit-failure", SubmitFailureController)

import SubmitOnToggleController from "./submit_on_toggle_controller"
application.register("submit-on-toggle", SubmitOnToggleController)

import TabScrollController from "./tab_scroll_controller"
application.register("tab-scroll", TabScrollController)

import TableScrollController from "./table_scroll_controller"
application.register("table-scroll", TableScrollController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TermsOfServiceController from "./terms_of_service_controller"
application.register("terms-of-service", TermsOfServiceController)

import TextMessagesController from "./text_messages_controller"
application.register("text-messages", TextMessagesController)

import TimeDisplayController from "./time_display_controller"
application.register("time-display", TimeDisplayController)

import TurboBroadcastSyncController from "./turbo_broadcast_sync_controller"
application.register("turbo-broadcast-sync", TurboBroadcastSyncController)

import TurboVisitController from "./turbo_visit_controller"
application.register("turbo-visit", TurboVisitController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import UseTextController from "./use_text_controller"
application.register("use-text", UseTextController)

import UserController from "./user_controller"
application.register("user", UserController)

import VerificationController from "./verification_controller"
application.register("verification", VerificationController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
